import request from '@/utils/request'

export function list(query) {
  return request({
    url: '/sys/dept/list',
    method: 'get',
    params: query
  })
}

export function info(id) {
  return request({
    url: '/sys/dept/info/' + id,
    method: 'get'
  })
}

export function save(data) {
  return request({
    url: '/sys/dept/save',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/sys/dept/update',
    method: 'post',
    data
  })
}

export function remove(data) {
  return request({
    url: '/sys/dept/delete',
    method: 'post',
    data
  })
}

